import React, { useContext } from 'react';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';

import ApiConnectionDialog from '@totem/components/administration/apiConnections/ApiConnectionDialog';
import ApiConnectionsContext from '@totem/components/administration/apiConnections/ApiConnectionsContext';
import ApiConnectionsTable from '@totem/components/administration/apiConnections/ApiConnectionsTable';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

export const ApiConnectionsExtra = () => {
  const { data, onRefresh, onAdd } = useContext(ApiConnectionsContext);

  return (
    <Space>
      <RecordCountBadge count={data.length} />
      <Tooltip title="Add Connection">
        <Button icon={<PlusOutlined />} onClick={onAdd} type="primary">
          Add
        </Button>
      </Tooltip>
      <Tooltip title="Refresh">
        <Button icon={<ReloadOutlined />} onClick={onRefresh} />
      </Tooltip>
    </Space>
  );
};

const ApiConnectionsLayout = () => (
  <>
    <ApiConnectionsTable />
    <ApiConnectionDialog />
  </>
);

export default ApiConnectionsLayout;
